import { getEntries } from '@pkgs/api/utils';

import { FEATURE_FLAGS, type FeatureFlagDetails, type FeatureFlag } from '@/consts/featureFlags';

export type AppMetadataFeatureFlags = Record<FeatureFlag, FeatureFlagDetails & { enabled: boolean }>;

export type AppMetadata = {
  app: {
    version: string;
  };
  build: {
    timestamp: string | null;
  };
  dependencies: Record<string, string>;
  featureFlags: AppMetadataFeatureFlags;
};

type CreateAppMetadataParams = {
  featureFlags?: Record<FeatureFlag, boolean>;
};

export const parseDependencyVersions = (rawDependencyVersions: string | undefined): Record<string, string> => {
  if (!rawDependencyVersions) return {};

  try {
    return JSON.parse(rawDependencyVersions) as Record<string, string>;
  } catch (error) {
    console.error(error);
    return {};
  }
};

export const createAppMetadata = ({ featureFlags }: CreateAppMetadataParams): AppMetadata => {
  const version = process.env.NEXT_PUBLIC_RELEASE_VERSION ?? 'unknown';

  const featureFlagsMetadata: AppMetadataFeatureFlags = getEntries(FEATURE_FLAGS).reduce((acc, [key, value]) => {
    if (featureFlags?.[key] === undefined) return acc;
    acc[key] = {
      ...value,
      enabled: featureFlags[key],
    };
    return acc;
  }, {} as AppMetadataFeatureFlags);

  return {
    app: {
      version,
    },
    build: {
      timestamp: process.env.NEXT_PUBLIC_APP_BUILD_TIMESTAMP ?? null,
    },
    dependencies: parseDependencyVersions(process.env.NEXT_PUBLIC_EV_DEPENDENCY_VERSIONS),
    featureFlags: featureFlagsMetadata,
  };
};
